module.exports = __webpack_public_path__ + "static/media/portfolio8.c1215ba7.jpg";